export default 'production'
// export default 'development';
// export default 'local'




// WEBPACK FOOTER //
// ./src/mode.js